export default "__VITE_ASSET__B59yHgB9__"